import { EntityDialog, HtmlContentEditor } from "@serenity-is/corelib";
import { Authorization, Config, ErrorHandling } from "@serenity-is/corelib/q";
import { IdleTimeout } from "./Helpers/idleTimeout";
import { siteLanguageList } from "./Helpers/LanguageList";

(window as any).android = (window as any).android || {};

Config.rootNamespaces.push('Curbtender');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";

if ($.fn['colorbox']) {
    $.fn['colorbox'].settings.maxWidth = "95%";
    $.fn['colorbox'].settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
$(() => {
    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {

        new IdleTimeout({
            activityTimeout: 120 * 60,
            warningDuration: 2 * 60
        });
    }
});